import { Component, DOCUMENT, Inject } from '@angular/core';
import { SystemResponse } from '../../models/SystemsModel';
import { SystemsService } from '../../services/systems-service';
import { Router } from '@angular/router';
import { LoaderService } from '../../../../core/services/loader/loader-service';
import { KeyStorageUtil } from '../../../../shared/utils/keystorage';
import { UsuarioAPI } from '../../../../core/models/AuthModel';
import { UtilCatService } from '../../../../shared/utils/UtilCatService';
import { ToastService } from '../../../../core/services/toast/toast-service';
import { environment } from '../../../../../enviroments/enviroment';

@Component({
  selector: 'app-home-page',
  imports: [],
  templateUrl: './home-page.html',
  styleUrl: './home-page.css',
})
export class HomePage {
  //user data
  user: UsuarioAPI = KeyStorageUtil.getItem('usuario')!;
  isAdmin: boolean = UtilCatService.isSuperUser();
  userNew: boolean = false;

  ngOnInit() {
    this.userNew = UtilCatService.hasNewUserProfile();

    if (this.userNew) {
      this.toastService.showToast(
        'Estimad@ usuari@ nuev@, no posee un perfil asignado. Favor ponerse en contacto con el administrador de sistema.',
        'info'
      );
      this.router.navigate(['/login']);
    } else {
      this.getSystems();
    }
  }

  constructor(
    private toastService: ToastService,
    private systemsService: SystemsService,
    private router: Router,
    private loaderService: LoaderService,
    private utilCatService: UtilCatService
  ) {}
  //systems data
  loading: boolean = false;
  systems: SystemResponse[] = [];
  getSystems = () => {
    this.loaderService.showLoader();

    this.systemsService.fetchSystemsData().subscribe({
      next: (res) => {
        KeyStorageUtil.setItem('systems', res);
        if (this.isAdmin) {
          this.systems = res;
        } else {
          this.systems = UtilCatService.getUserUniqueSystems();
          this.systems.forEach((system: SystemResponse) => {
            system.img = res.find((s) => s.nombre === system.nombre)?.img || '';
          });
        }
      },

      complete: () => {
        this.loaderService.hideLoader();
      },

      error: (err) => {
        console.error('Error fetching systems data:', err);
        this.toastService.showToast(
          'Error al cargar los sistemas. Por favor, inténtelo de nuevo más tarde.',
          'error'
        );
        this.loaderService.hideLoader();
      },
    });
  };

  handleEnterSystem(item: SystemResponse) {
    this.loaderService.showLoader();
    this.utilCatService.enterTheSystem(item);
    this.loaderService.hideLoader();
  }
}
